import { computed } from 'vue';
import { cloneDeep } from 'lodash';
import BaseFilterControls from './BaseFilterControls';
export default class TrackFilterControls extends BaseFilterControls {
    constructor(params) {
        super(params);
        /**
         * Override filtered track annotations to include logic
         * for filtering based on group membership as well
         */
        this.filteredAnnotations = computed(() => {
            const checkedSet = new Set(this.checkedTypes.value);
            const filteredGroupsSet = new Set(params.groupFilterControls.enabledAnnotations.value
                .map((v) => v.annotation.id));
            const confidenceFiltersVal = cloneDeep(this.confidenceFilters.value);
            const resultsArr = [];
            const resultsIds = new Set();
            params.sorted.value.forEach((annotation) => {
                let enabledInGroupFilters = true;
                const groups = params.lookupGroups(annotation.id);
                if (groups.length) {
                    /**
                     * This track is a member of a group,
                     * so check that at least one of its groups is enabled
                     */
                    enabledInGroupFilters = groups.some((group) => filteredGroupsSet.has(group.id));
                }
                const confidencePairIndex = annotation.confidencePairs
                    .findIndex(([confkey, confval]) => {
                    const confidenceThresh = Math.max(confidenceFiltersVal[confkey] || 0, confidenceFiltersVal.default);
                    return confval >= confidenceThresh && checkedSet.has(confkey);
                });
                /* include annotations where at least 1 confidence pair is above
                 * the threshold and part of the checked type set */
                if ((confidencePairIndex >= 0 || annotation.confidencePairs.length === 0)
                    && enabledInGroupFilters && !resultsIds.has(annotation.id)) {
                    resultsIds.add(annotation.id);
                    resultsArr.push({
                        annotation,
                        context: {
                            confidencePairIndex,
                        },
                    });
                }
            });
            return resultsArr;
        });
    }
}
